import ConfigService from '../index'
class CatracasService extends ConfigService {
    constructor(){
        super('catracas/api/v1/')
    }
    async update_solicitacao_visitante(data, id){
        return await this.patch(`solicitacao-cadastro-visitante/${id}/`, data)
    }
    async delete_solicitacao_visitante(id){
        return await this.delete(`solicitacao-cadastro-visitante/${id}/`)
    }
    async post_solicitacao_visitante(data){
        return await this.post('solicitacao-cadastro-visitante/', data)
    }
    async list_solicitacao_visitantes(params){
        return await this.get('solicitacao-cadastro-visitante/', params)
    }
    async lista_parametro_status_matricula(){
        return await this.get(`status-situacao-matricula/`, {page_size: 50})
    }
    async update_parametro_status_matricula(data, id){
        return await this.patch(`status-situacao-matricula/${id}/`, data)
    }
}
export default CatracasService
